import { HttpRequestSettings, apis } from './../shared/models/request-settings';
import { HttpWebApiService } from '@sb-shared/services/http-web-api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BalanceService {

  urlBase = 'WebBalance/';
  config: HttpRequestSettings = {
    api: apis.Web
  }

  constructor(private http: HttpWebApiService) { }

  getAllBalances(): Observable<any> {
    return this.http.get(this.urlBase + 'GetAllBalances', this.config);
  }

  getTransactions(eventsFrom: Date, eventsTo: Date): Observable<any> {
    return this.http.get('../Balance/GetTransactions', {
      ...this.config,
      params: { eventsFromUtc: eventsFrom, eventsToUtc: eventsTo }
    });
  }

  postValidPayments(payments: any[]): Observable<any> {
    return this.http.post('../Balance/ValidPayments', { currentPersonId: 0, dtos: payments }, this.config);
  }

  getTransactionsForAccount(accountTypeId: number, includeSource: boolean, from: Date, to: Date): Observable<any> {
    return this.http.get(this.urlBase + 'GetTransactionsForAccount', {
      ...this.config,
      params: { accountType: accountTypeId, includeSource, from, to }
    });
  }

  getBalanceForAccountType(accountType: number): Observable<any> {
    return this.http.get(this.urlBase + 'GetBalanceForAccount', {
      ...this.config,
      params: { accountType }
    });
  }
}
